import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from '../components/Layout';
import Loading from '../components/Loading';
import Home from '../pages/home';
import Service from '../pages/service';

// 只对较大的页面使用 lazy 加载
const About = React.lazy(() => import('../pages/about'));
const Contact = React.lazy(() => import('../pages/contact'));
const TruckInsurance = React.lazy(
  () => import('../pages/product/truck-insurance')
);

const Router: React.FC = () => {
  return (
    <BrowserRouter>
      <Layout>
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/service" element={<Service />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route
              path="/product/truck-insurance"
              element={<TruckInsurance />}
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </Layout>
    </BrowserRouter>
  );
};

export default Router;
